export default function RiskBadge({ level = 1 }: { level?: 1 | 2 | 3 | 4 | 5 }) {
	return (
		<>
			{level === 5 && (
				<>
					<span className="inline-block whitespace-nowrap rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-800 selection:flex-shrink-0">
						Level 5 Risk
					</span>
				</>
			)}
			{level === 4 && (
				<>
					<span className="inline-block whitespace-nowrap rounded-full bg-orange-100 px-2 py-0.5 text-xs font-medium text-orange-800 selection:flex-shrink-0">
						Level 4 Risk
					</span>
				</>
			)}
			{level === 3 && (
				<>
					<span className="inline-block whitespace-nowrap rounded-full bg-yellow-100 px-2 py-0.5 text-xs font-medium text-yellow-800 selection:flex-shrink-0">
						Level 3 Risk
					</span>
				</>
			)}
			{level === 2 && (
				<>
					<span className="inline-block whitespace-nowrap rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-800 selection:flex-shrink-0">
						Level 2 Risk
					</span>
				</>
			)}
			{level === 1 && (
				<>
					<span className="inline-block whitespace-nowrap rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800 selection:flex-shrink-0">
						Level 1 Risk
					</span>
				</>
			)}
		</>
	);
}
